import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { ApiError } from '../../../../Shared/interfaces/ApiError';
import { ApiResponseKeys } from '../../../../Shared/interfaces/ApiResponse';
import useApiClient from '../../../../Shared/services/api';
import { useAppContext } from '../../../../Shared/store/appContext';
import { EndpointQueryKeys } from '../../../constants/endpoints';
import { QueueSheetManagementRows } from '../interface/QueueSheetInterface';
import { cancelBooking } from '../services/service';

export const useCancelBookingMutation = (
    setIsCancelModalOpen: React.Dispatch<React.SetStateAction<boolean>>,
    setBookingToCancel: React.Dispatch<
        React.SetStateAction<QueueSheetManagementRows | null>
    >,
    setSuccessMessage: React.Dispatch<React.SetStateAction<string | null>>,
    setCurrentPage: React.Dispatch<React.SetStateAction<number>>
) => {
    const { t } = useTranslation();
    const api = useApiClient();
    const queryClient = useQueryClient();
    const {
        state: { selectedArtEventId },
    } = useAppContext();
    const artEventId = selectedArtEventId ?? '';

    return useMutation<ApiResponseKeys, ApiError, string>({
        mutationFn: (bookingId: string) => cancelBooking(api, bookingId),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [EndpointQueryKeys.GET_BOOKING_SHEET, artEventId],
            });
            setCurrentPage(0);
            setIsCancelModalOpen(false);
            setBookingToCancel(null);
            setSuccessMessage(t('cancel-booking-success-message'));
        },
    });
};
